import DCFButtonToggle from '@dcf/js/components/dcf-button-toggle.js';

export default class UNLButtonToggle extends DCFButtonToggle {
    constructor(toggleButtonElement, options={}) {
        super(toggleButtonElement, options);
    }
}
